import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


import { WorkflowsService } from '../../../../../services/settings/workflows.service';
import { Subscription } from 'rxjs';


import { Workflow } from '@core/objects/workflow';

@Component({
    selector: 'settings-workflows-add-form',
    templateUrl: './add-form.component.html',
    styleUrls: ['./add-form.component.scss']
})
export class SettingsWorkflowsAddFormComponent implements OnInit{

	public readonly STATUS_LOADING = 0;
	public readonly STATUS_DONE = 1;

    @Output() cancel = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();

    public status: Number = 0;

    public form: FormGroup;
    public showInstructions: boolean =  false;

	constructor(public workflowsSrv: WorkflowsService, private formBuilder: FormBuilder){}

	ngOnInit(){
		this.init();

	}

    init(){
        this.form = this.formBuilder.group({
            name: ['', [Validators.required]]
		});
    }

	onCancel(event) {
        console.log(" cancel triggered")
        this.cancel.emit(event);
        this.cleanForm();
	}

    add(){
        if(this.form.invalid)
			return;

        this.workflowsSrv.addWorkflow$(this.form.value.name).subscribe((data: Workflow) => {
            console.debug(" post: new wf added",data);
            this.cleanForm();
            this.submit.emit()
        });

    }

    cleanForm(){
		this.form.reset({name: ''});
	}

}
